/**
 * Stay Close Buddy — Theme JavaScript
 * Handles: reveal animations, FAQ accordion, product swatches, nav scroll
 */
(function () {
  'use strict';

  /* -------------------------------------------------- *
   * REVEAL ON SCROLL (IntersectionObserver)
   * -------------------------------------------------- */
  function initReveal() {
    document.documentElement.classList.add('scb-anim');

    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.scb-reveal').forEach(function (el) {
        el.classList.add('scb-in');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('scb-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.scb-reveal').forEach(function (el) {
      io.observe(el);
    });
  }

  /* -------------------------------------------------- *
   * FAQ ACCORDION
   * -------------------------------------------------- */
  function initFaq() {
    document.querySelectorAll('.scb-faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.scb-faq-item');
        var answer = item.querySelector('.scb-faq-a');
        var isOpen = item.classList.contains('scb-open');

        // Close all others
        document.querySelectorAll('.scb-faq-item.scb-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('scb-open');
            var a = openItem.querySelector('.scb-faq-a');
            if (a) a.style.height = '0';
            var openBtn = openItem.querySelector('.scb-faq-q');
            if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
          }
        });

        if (isOpen) {
          item.classList.remove('scb-open');
          answer.style.height = '0';
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('scb-open');
          var inner = answer.querySelector('.scb-faq-a-inner');
          answer.style.height = (inner ? inner.scrollHeight : 0) + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* -------------------------------------------------- *
   * PRODUCT COLOR SWATCHES
   * -------------------------------------------------- */
  function initSwatches() {
    document.querySelectorAll('[data-scb-swatches]').forEach(function (wrap) {
      var target = wrap.dataset.scbSwatches;
      var tracker = document.querySelector('[data-scb-tracker="' + target + '"]');

      wrap.querySelectorAll('.scb-swatch').forEach(function (sw) {
        sw.addEventListener('click', function () {
          wrap.querySelectorAll('.scb-swatch').forEach(function (s) { s.classList.remove('scb-active'); });
          sw.classList.add('scb-active');
          if (tracker) {
            tracker.style.setProperty('--dev-color', sw.dataset.color);
          }
          // Switch product videos by colour (homepage product card)
          var card = wrap.closest('.scb-prod');
          if (card) {
            card.querySelectorAll('.scb-prod-video[data-color]').forEach(function (v) {
              var on = v.dataset.color === sw.dataset.color;
              v.classList.toggle('scb-active', on);
              if (on) { try { v.play(); } catch (e) {} } else { try { v.pause(); } catch (e) {} }
            });
            // Point the buy button at the product with this colour pre-selected
            var buyBtn = card.querySelector('[data-scb-buy]');
            if (buyBtn && sw.dataset.variant) {
              var base = buyBtn.getAttribute('data-href') || buyBtn.getAttribute('href').split('?')[0];
              buyBtn.setAttribute('href', base + '?variant=' + sw.dataset.variant);
            }
          }
        });
      });
    });
  }

  /* -------------------------------------------------- *
   * MOBILE MENU (fallback if Horizon doesn't handle it)
   * -------------------------------------------------- */
  function initMobileMenu() {
    var toggle = document.getElementById('scbNavToggle');
    var menu = document.getElementById('scbMobileMenu');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('scb-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        menu.classList.remove('scb-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  /* -------------------------------------------------- *
   * SMOOTH ANCHOR SCROLL (offset for fixed nav)
   * -------------------------------------------------- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var id = anchor.getAttribute('href').slice(1);
        if (!id) return;
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        var offset = 88;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* -------------------------------------------------- *
   * INIT
   * -------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initReveal();
    initFaq();
    initSwatches();
    initMobileMenu();
    initSmoothScroll();
  }

  /* Re-init on Shopify theme editor section updates */
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initFaq();
    initSwatches();
  });

})();
